import { findActiveStoreView } from './findActiveStoreView'
import { useStoreViews } from './storeViews'

const useActiveStoreView = () => {
  const storeViews = useStoreViews()
  const activeStoreView = findActiveStoreView(storeViews)
  if (!activeStoreView) {
    throw new Error('Cannot find the active StoreView!')
  }

  return activeStoreView
}

export default useActiveStoreView
